import {RouterModule, Routes} from '@angular/router';
import { LogoOccidenteComponent } from './components/shared/logo/logo-occidente/logo-occidente.component';
import { LogoComponent } from './components/shared/logo/logo.component';

const APP_ROUTES: Routes = [
    {path: '**', pathMatch: 'prefix', component:LogoOccidenteComponent}
];

// tslint:disable-next-line: eofline
export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES);
